export const FILL_LEVELS = ['high', 'medium', 'low'] as const
export type FillLevel = (typeof FILL_LEVELS)[number]
